import { messages } from "../../lib/messages";
import { showsPaymentMethodChoice } from "./checkoutFields";
import type { Shop } from "../../api/shop";

interface PaymentMethodSectionProps {
  shop: Shop;
  value: string;
  onChange(value: string): void;
}

/**
 * PaymentMethodSection — радиокнопки способа оплаты (docs/07-miniapp-ux.md §2.5).
 * Единственный разрешённый способ не показывается вовсе — сумма магазина
 * уже подставлена молча вызывающей страницей.
 */
export function PaymentMethodSection({ shop, value, onChange }: PaymentMethodSectionProps) {
  if (!showsPaymentMethodChoice(shop)) {
    return null;
  }

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="text-sm text-hint">{messages.paymentMethodLabel}</legend>
      {shop.payment_methods.map((method) => (
        <label key={method.code} className="flex items-center gap-2 text-text">
          <input
            type="radio"
            name="payment_method"
            required
            value={method.code}
            checked={value === method.code}
            onChange={() => onChange(method.code)}
          />
          {method.label}
        </label>
      ))}
    </fieldset>
  );
}
